"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
const tsx = __importStar(require("vue-tsx-support"));
const utils = __importStar(require("@/utils"));
exports.default = tsx.component({
    functional: true,
    props: {
        date: (0, vue_strict_prop_1.default)(Object).validator(moment_1.default.isMoment).required,
        tag: vue_strict_prop_1.default.ofType().default('span'),
    },
    render(h, ctx) {
        const { date } = ctx.props;
        const now = ctx.parent.$getRootInstance().$getNow(date);
        const isToday = (0, moment_1.default)(date).local().isSame(now, 'day');
        const displayText = isToday
            ? utils.datetime.readableTimeOnly(date)
            : utils.datetime.readableShortDate(date);
        return h(ctx.props.tag, {
            attrs: {
                title: utils.datetime.readableFormatDate(date),
                ...ctx.data.attrs,
            },
            class: [ctx.data.class, ctx.data.staticClass],
        }, [displayText]);
    },
});
